/* eslint-disable */

import React from 'react';
import { RightOutlined } from '@ant-design/icons';

export function LicenseFormHeader({ pageTitle, onBack }) {
  return (
    <div className='license-form-header'>
      <div className='license-form-breadcrumb'>
        <button type='button' className='license-form-breadcrumb-link' onClick={onBack}>
          สิทธิ์การเข้าถึงหมวดหมู่สินค้า
        </button>
        <RightOutlined className='license-form-breadcrumb-sep' />
        <span className='license-form-breadcrumb-current'>{pageTitle}</span>
      </div>
      <h1 className='license-form-title'>{pageTitle}</h1>
    </div>
  );
}
